import { useMutation } from '@tanstack/react-query';
import { orpc, useInvalidateRpcQueryFn } from '@/api/rpc/client';

/**
 * Aggregate several AP invoice lines into one match. Refreshes the invoice
 * (match status) and the line match lists, since the lines' matches change.
 */
export function useAggregateAPInvoiceLineItems() {
  const invalidateQueries = useInvalidateRpcQueryFn((orpc) => [
    orpc.accountsPayable.invoices.get.key(),
    orpc.accountsPayable.invoices.list.key(),
    orpc.core.entityAssociations.list.key(),
  ]);
  return useMutation(
    orpc.accountsPayable.invoices.aggregateLineItems.mutationOptions({
      onSuccess: () => {
        invalidateQueries();
      },
    }),
  );
}
